<script setup>
/* eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text */
import { Handle, Position } from '@vue-flow/core';
import { types, title } from './model';
const props = defineProps({
  id: { type: String, required: true },
  type: { type: String, required: true },
  data: { type: Object, required: true },
  selected: Boolean,
});
</script>

<template>
  <div
    :data-node-id="id"
    class="flow-native-node rounded-lg border bg-n-background p-4 text-n-slate-12 shadow-sm"
    :class="selected ? 'border-n-brand' : 'border-n-weak'"
  >
    <Handle
      v-if="type !== 'event'"
      id="in"
      type="target"
      :position="Position.Top"
    />
    <div
      class="mb-2 flex items-center justify-between gap-3 text-xs text-n-slate-11"
    >
      <span>{{ types.find(t => t.value === type)?.label }}</span
      ><span class="node-grip cursor-grab" aria-hidden="true">⠿</span>
    </div>
    <div class="break-words text-sm font-medium">{{ title(props) }}</div>
    <p
      v-if="type === 'message'"
      class="mt-2 line-clamp-3 whitespace-pre-wrap break-words text-xs text-n-slate-11"
    >
      {{ data.text }}
    </p>
    <div
      v-if="type === 'condition'"
      class="mt-3 flex justify-between text-xs text-n-slate-11"
    >
      <span>Да</span><span>Нет</span>
    </div>
    <Handle
      v-if="!['stop', 'next'].includes(type)"
      id="yes"
      type="source"
      :position="Position.Bottom"
      :class="type === 'condition' ? 'handle-left' : ''"
    />
    <Handle
      v-if="type === 'condition'"
      id="no"
      type="source"
      :position="Position.Bottom"
      class="handle-right"
    />
  </div>
</template>

<style scoped>
.flow-native-node {
  width: 230px;
}
.handle-left {
  left: 25%;
}
.handle-right {
  left: 75%;
}
</style>
